var React = require('react');

function IcAwsCloudfrontStreamingDistribution (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M20,0C8.972,0,0,8.972,0,20s8.972,20,20,20s20-8.972,20-20S31.028,0,20,0z M20,38.298\n\tC9.911,38.298,1.702,30.09,1.702,20C1.702,9.911,9.911,1.702,20,1.702c10.09,0,18.298,8.209,18.298,18.298\n\tC38.298,30.09,30.09,38.298,20,38.298z M20.851,29.913V6.434h-1.702v23.479l-5.731-5.724l-1.203,1.205l7.183,7.174\n\tc0.166,0.165,0.384,0.249,0.601,0.249s0.436-0.083,0.602-0.249l7.183-7.174l-1.203-1.205L20.851,29.913z"}));
}

IcAwsCloudfrontStreamingDistribution.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsCloudfrontStreamingDistribution;

IcAwsCloudfrontStreamingDistribution.default = IcAwsCloudfrontStreamingDistribution;
